<template>
    <div class="mx-auto col-lg-6 col-md-8 col-sm-12 header-margin">
        <div class="text-center p-2" style="margin-bottom: 30px">
            <h3>{{ $t('account.changeMail.title') }}</h3>
        </div>
        <form @submit.prevent="handleOnSubmit">
            <div class="text-center">

                <div class="show-check-email-message">
                    <h5 class="text-black-50" v-html="$t('auth.changeEmailRequest.text')">
                    </h5>
                </div>

                <div class="text-center btn-position">
                    <div class="pt-5 ">
                        <button type="submit" :disabled="submitBtnDisabled()" class="btn btn-primary">{{ $t('auth.changeEmailRequest.button') }}</button>
                    </div>
                </div>
            </div>
        </form>

    </div>
</template>

<script>
    import userService from '../../services/UserService';

    export default {
        name: 'change-mail-request',

        data() {
            return {
                errors: this.getDefaultFields(),
                submitted: false,
            }
        },

        mounted() {
        },

        created() {

        },

        methods: {
            getDefaultFields() {
                return {
                };
            },

            submitBtnDisabled() {
                return this.submitted;
            },

            async handleOnSubmit() {
                this.errors = this.getDefaultFields();

                try {
                    this.submitted = true;
                    await userService.resetMailRequest();
                    this.$router.push('/account/change-mail-request-confirm');
                } catch (err) {
                    if (err.response.data.errors) {
                        err.response.data.errors.forEach(errItem => {
                            if (errItem.field) {
                                this.errors[errItem.field] = errItem.message[0];
                                if (errItem.message[0] === 'USER_TOKEN_DATA_WITHIN_24H') {
                                    this.$router.push('/account/change-mail-error');
                                }
                            }
                        })
                    }
                } finally {
                    this.submitted = false;
                }
            }
        }
    }
</script>

<style scoped>
    .password-requirement {
        margin: 40px 0px 40px 0px;
    }
    .password-requirement p {
        margin-bottom: 1em;
    }
    .password-requirement ul {
        list-style: disc;
    }
    .password-requirement ul li {
        margin-left: 3.5em;
    }

    /*PC PAD用css*/
    @media screen and (min-width: 479px) { /*ウィンドウ幅が479px以上の場合に適用*/
        .invalid-errors-hiddens{
            visibility:hidden;
            height: 67px;
            margin-top: 4px;
            margin-bottom: 4px;
        }
        .invalid-errors{
            min-height:30px;
            height:auto !important;
            height:30px;
            margin-top: 4px;
            margin-bottom: 4px;
        }
    }
    /*スマホ用css*/
    @media screen and (max-width: 479px) { /*ウィンドウ幅が最大479pxまでの場合に適用*/
        .invalid-errors-hiddens{
            visibility:hidden;
            height: 51px;
            margin-top: 3px;
            margin-bottom: 5px;
        }
        .invalid-errors{
            min-height:10px;
            height:auto !important;
            height:10px;
            margin-top: 4px;
        }
        .col-form-label{
            padding-top: 0px;
        }
        .btn-position{
            padding-top: 10px;
        }
    }
</style>
